import React from 'react';
import { Grid, Typography, Box, Button, Container } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useNavigate } from 'react-router-dom';

export default function Hero() {
    const navigate = useNavigate();

    return (
        <Box
            id="hero"
            sx={{
                minHeight: '90vh',
                display: 'flex',
                alignItems: 'center',
                background: 'linear-gradient(180deg, #0a0a0a 0%, #111 100%)',
                position: 'relative',
                overflow: 'hidden',
                pt: 8,
            }}
        >
            <Box sx={{
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                opacity: 0.05,
                backgroundImage: 'linear-gradient(#333 1px, transparent 1px), linear-gradient(90deg, #333 1px, transparent 1px)',
                backgroundSize: '40px 40px',
            }} />

            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                <Grid container spacing={4} alignItems="center" justifyContent="center">
                    <Grid item xs={12} md={10} lg={8} sx={{ textAlign: 'center' }}>
                        <Box sx={{
                            display: 'inline-block',
                            bgcolor: 'rgba(44, 187, 93, 0.1)',
                            color: '#2cbb5d',
                            px: 2, py: 0.5,
                            borderRadius: '20px',
                            mb: 3,
                            fontSize: '0.875rem',
                            fontWeight: 600,
                        }}>
                            Evolving Systems | Living Systems | AI Systems
                        </Box>

                        <Typography component="h1" variant="h2" fontWeight={800} color="#fff" sx={{ mb: 2, lineHeight: 1.2, letterSpacing: '-1px', fontSize: 'clamp(1.75rem, 8vw, 3.75rem)', overflowWrap: 'anywhere' }}>
                            Simulate, Understand, Automate and <br />
                            <span style={{
                                    background: 'linear-gradient(90deg,rgb(255, 136, 0) 0%,rgb(255, 0, 0) 100%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                }}>
                                Evolve<sup>X</sup>&nbsp;
                             </span>
                            
                            <span style={{
                                background: 'linear-gradient(90deg, #2cbb5d 0%, #1e8e45 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                            }}>
                                Intelligence
                            </span> 
                       
                        </Typography>

                        <Typography variant="h6" color="#a1a1aa" sx={{ mb: 5, maxWidth: '650px', mx: 'auto', lineHeight: 1.6 }}>
                            Biology, mobility, generative art, and arcade agents — in one place.
                        </Typography>

                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                            <Button
                                variant="contained"
                                size="large"
                                startIcon={<PlayArrowIcon />}
                                onClick={() => navigate('/arcade')}
                                sx={{
                                    bgcolor: '#2cbb5d',
                                    color: '#000',
                                    fontWeight: 'bold',
                                    px: 4, py: 1.5,
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    fontSize: '1rem',
                                    '&:hover': { bgcolor: '#249a4d' },
                                }}
                            >
                                Enter Arcade
                            </Button>
                            <Button
                                variant="outlined"
                                size="large"
                                onClick={() => navigate('/docs')}
                                sx={{
                                    borderColor: '#333',
                                    color: '#fff',
                                    px: 4, py: 1.5,
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    fontSize: '1rem',
                                    '&:hover': { borderColor: '#555', bgcolor: 'rgba(255,255,255,0.05)' },
                                }}
                            >
                                Read Docs
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}
